import React, {PureComponent} from 'react';
import {BadgeAd} from '..';
import {debounce} from 'utils';

import styles from './styles';

export default class ImageEditor extends PureComponent {
  container = null;
  canvasContainer = null;
  baseCanvas = null;
  selectionCanvas = null;

  constructor(props) {
    super(props);

    const {image, maxWidth} = props;

    this.state = {
      imageHeight: Math.min(image.height, maxWidth, (maxWidth / image.width) * image.height)
    };
  }

  // Scale the canvas to ensure it fits on the screen
  scaleCanvas = debounce(() => {
    const {maxWidth} = this.props;
    const {imageHeight} = this.state;
    const containerWidth = this.container.getBoundingClientRect().width;
    const containerHeight = containerWidth / maxWidth * imageHeight;
    const scaleAmount = Math.min(window.innerHeight / containerHeight, 1);

    this.container.style.height = `${containerHeight * scaleAmount}px`;
    this.canvasContainer.style.transform = `scale(${scaleAmount})`;
  }, 16);

  // Add an event listener to the window so we know how to scale our canvi
  componentDidMount() {
    // As the window resizes, scale the canvas to fit
    window.addEventListener('resize', this.scaleCanvas);
  }

  // Clean up resources once we don't need them
  componentWillUnmount() {
    window.removeEventListener('resize', this.scaleCanvas);
    this.scaleCanvas.cancel();
    this.container = null;
    this.canvasContainer = null;
    this.baseCanvas = null;
    this.selectionCanvas = null;
  }

  render() {
    const {maxWidth} = this.props;
    const {imageHeight} = this.state;

    // Scale the canvas on initial render to make sure it fits
    this.scaleCanvas();

    return (
      <div className={styles.editor}>
        <div
          ref={(container) => this.container = container}
          className={styles.container}
          style={{
            height: `${imageHeight}px`
          }}
        >
          <div ref={(canvasContainer) => this.canvasContainer = canvasContainer}>
            <canvas
              ref={(baseCanvas) => this.baseCanvas = baseCanvas}
              className={styles.canvas}
              width={maxWidth}
              height={imageHeight}
            />
            <canvas
              ref={(selectionCanvas) => this.selectionCanvas = selectionCanvas}
              className={styles.canvas}
              width={maxWidth}
              height={imageHeight}
            />
          </div>
        </div>
        <BadgeAd />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ImageEditor/index.jsx